import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Tag from "../views/Tag.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/tag",
    name: "Tag",
    component: Tag,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
